if (!window.Eurus.loadedScript.has('cep-shipping.js')) {
  window.Eurus.loadedScript.add('cep-shipping.js');

  const PROVINCES = {
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'São Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins'
  };

  const CEP_RANGES = [
    [1000000, 19999999, 'SP'],
    [20000000, 28999999, 'RJ'],
    [29000000, 29999999, 'ES'],
    [30000000, 39999999, 'MG'],
    [40000000, 48999999, 'BA'],
    [49000000, 49999999, 'SE'],
    [50000000, 56999999, 'PE'],
    [57000000, 57999999, 'AL'],
    [58000000, 58999999, 'PB'],
    [59000000, 59999999, 'RN'],
    [60000000, 63999999, 'CE'],
    [64000000, 64999999, 'PI'],
    [65000000, 65999999, 'MA'],
    [66000000, 68899999, 'PA'],
    [68900000, 68999999, 'AP'],
    [69000000, 69299999, 'AM'],
    [69300000, 69399999, 'RR'],
    [69400000, 69899999, 'AM'],
    [69900000, 69999999, 'AC'],
    [70000000, 72799999, 'DF'],
    [72800000, 72999999, 'GO'],
    [73000000, 73699999, 'DF'],
    [73700000, 76799999, 'GO'],
    [76800000, 76999999, 'RO'],
    [77000000, 77999999, 'TO'],
    [78000000, 78899999, 'MT'],
    [79000000, 79999999, 'MS'],
    [80000000, 87999999, 'PR'],
    [88000000, 89999999, 'SC'],
    [90000000, 99999999, 'RS']
  ];

  let labels = null;
  let chain = Promise.resolve();

  function enqueue(task) {
    const run = chain.then(task, task);
    chain = run.then(() => undefined, () => undefined);
    return run;
  }

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function loadLabels(el) {
    if (labels || !el) return;
    const node = el.dataset && el.dataset.moneyFormat ? el : el.closest('[data-money-format]');
    if (!node) return;
    labels = {
      moneyFormat: node.dataset.moneyFormat,
      single: node.dataset.single,
      multiple: node.dataset.multiple,
      none: node.dataset.none,
      free: node.dataset.free,
      day: node.dataset.day,
      days: node.dataset.days,
      invalid: node.dataset.invalid,
      error: node.dataset.error,
      country: node.dataset.country || 'Brazil'
    };
  }

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatCep(digits) {
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }

  function formatDays(deliveryDays) {
    if (!Array.isArray(deliveryDays) || !deliveryDays.length || !labels) return '';
    const min = Number(deliveryDays[0]);
    const max = Number(deliveryDays[deliveryDays.length - 1]);
    if (Number.isNaN(min) || Number.isNaN(max)) return '';
    if (min === max) return `${min} ${min === 1 ? labels.day : labels.days}`;
    return `${min} a ${max} ${labels.days}`;
  }

  function formatPrice(price) {
    const amount = Number(price);
    if (!amount) return labels.free;
    const cents = Math.round(amount * 100);
    const helper = window.Alpine && window.Alpine.store('xHelper');
    if (helper && labels.moneyFormat) return helper.formatMoney(cents, labels.moneyFormat);
    return amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function provinceFromCep(cep) {
    const numeric = Number(cep);
    const match = CEP_RANGES.find(([start, end]) => numeric >= start && numeric <= end);
    return match ? PROVINCES[match[2]] : '';
  }

  async function resolveProvince(cep) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      if (response.ok) {
        const data = await response.json();
        if (!data.erro && data.uf && PROVINCES[data.uf]) return PROVINCES[data.uf];
        if (data.erro) return '';
      }
    } catch (error) {
      console.log(error);
    }
    return provinceFromCep(cep);
  }

  async function requestRates(cep, province) {
    const params = new URLSearchParams({
      'shipping_address[zip]': formatCep(cep),
      'shipping_address[country]': labels.country,
      'shipping_address[province]': province
    });
    const response = await fetch(`${shopifyRoot()}cart/shipping_rates.json?${params.toString()}`);
    const data = await response.json();
    if (!response.ok) {
      const message = data && (data.zip || data.province || data.country) ? labels.invalid : labels.error;
      return { rates: [], heading: '', error: message };
    }
    const list = data.shipping_rates || [];
    if (!list.length) return { rates: [], heading: labels.none, error: '' };
    return {
      rates: list.map((rate) => ({
        name: rate.presentment_name || rate.name,
        days: formatDays(rate.delivery_days),
        price: formatPrice(rate.price)
      })),
      heading: list.length === 1 ? labels.single : labels.multiple,
      error: ''
    };
  }

  function snapshotItems(items) {
    return items.map((item) => {
      const line = { id: item.variant_id, quantity: item.quantity };
      if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
      const planId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id;
      if (planId) line.selling_plan = planId;
      return line;
    });
  }

  async function restoreCart(snapshot) {
    const root = shopifyRoot();
    await fetch(`${root}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } });
    if (!snapshot.length) return;
    await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: snapshot })
    });
  }

  async function fetchCartRates(cep) {
    const province = await resolveProvince(cep);
    if (!province) return { rates: [], heading: '', error: labels.invalid };
    return enqueue(async () => {
      const cart = await fetch(`${shopifyRoot()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      if (!cart.item_count) return { rates: [], heading: labels.none, error: '' };
      return requestRates(cep, province);
    });
  }

  async function fetchProductRates(cep, variantId, quantity) {
    const province = await resolveProvince(cep);
    if (!province) return { rates: [], heading: '', error: labels.invalid };
    if (!variantId) return { rates: [], heading: '', error: labels.error };
    return enqueue(async () => {
      const root = shopifyRoot();
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      const snapshot = snapshotItems(cart.items);
      const same = snapshot.length === 1
        && String(snapshot[0].id) === String(variantId)
        && Number(snapshot[0].quantity) === Number(quantity)
        && !snapshot[0].properties
        && !snapshot[0].selling_plan;

      if (!same) {
        await fetch(`${root}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } });
        const added = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] })
        });
        if (!added.ok) {
          await restoreCart(snapshot);
          return { rates: [], heading: '', error: labels.error };
        }
      }

      try {
        return await requestRates(cep, province);
      } finally {
        if (!same) await restoreCart(snapshot);
      }
    });
  }

  function publishCep(cep, source) {
    document.dispatchEvent(new CustomEvent('consulado:cep-set', { detail: { cep, source } }));
  }

  function publishClear(source) {
    document.dispatchEvent(new CustomEvent('consulado:cep-cleared', { detail: { source } }));
  }

  function savedCep() {
    return digitsOnly(localStorage.getItem('cart_shipping_zip'));
  }

  function rememberCep(digits) {
    if (!digits) {
      localStorage.removeItem('cart_shipping_zip');
      return;
    }
    localStorage.setItem('cart_shipping_zip', formatCep(digits));
  }

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xCepQuote', {
        cep: '',
        display: '',
        ready: false,
        loading: false,
        consulted: false,
        rates: [],
        error: '',
        heading: '',
        open: false,
        ignoreAway: false,
        requestId: 0,
        boot() {
          const saved = savedCep();
          this.cep = saved;
          this.display = formatCep(saved);
          this.ready = saved.length === 8;
        },
        ensure(el) {
          loadLabels(el);
          if (!this.cep) this.boot();
          if (this.ready) this.lookup(false);
        },
        onInput(raw, openPopup, input) {
          loadLabels(input);
          const digits = digitsOnly(raw);
          this.display = formatCep(digits);
          if (input) input.value = this.display;
          if (digits === this.cep) return;
          this.cep = digits;
          this.ready = digits.length === 8;
          this.rates = [];
          this.heading = '';
          this.error = '';
          this.consulted = false;
          this.open = false;
          rememberCep(digits);
          publishCep(digits, 'quote');
          if (this.ready) this.lookup(!!openPopup);
        },
        clear() {
          this.cep = '';
          this.display = '';
          this.ready = false;
          this.loading = false;
          this.consulted = false;
          this.rates = [];
          this.heading = '';
          this.error = '';
          this.open = false;
          this.requestId += 1;
          rememberCep('');
          publishClear('quote');
        },
        reopen() {
          this.open = true;
          this.ignoreAway = true;
          setTimeout(() => {
            this.ignoreAway = false;
          }, 0);
          if (this.ready && !this.consulted && !this.loading) this.lookup(true);
        },
        async lookup(openPopup) {
          if (!labels || this.cep.length !== 8) return;
          const cep = this.cep;
          const requestId = ++this.requestId;
          this.loading = true;
          this.error = '';
          if (openPopup) this.open = true;
          try {
            const result = await fetchCartRates(cep);
            if (requestId !== this.requestId || this.cep !== cep) return;
            this.rates = result.rates;
            this.heading = result.heading;
            this.error = result.error || '';
            this.consulted = !result.error;
          } catch (error) {
            console.log(error);
            if (requestId === this.requestId && this.cep === cep) this.error = labels.error;
          } finally {
            if (requestId === this.requestId) this.loading = false;
          }
        }
      });

      Alpine.store('xCepQuote').boot();

      document.addEventListener('consulado:cep-set', (event) => {
        if (!event.detail || event.detail.source !== 'product') return;
        const store = Alpine.store('xCepQuote');
        const digits = digitsOnly(event.detail.cep);
        if (digits === store.cep) return;
        store.cep = digits;
        store.display = formatCep(digits);
        store.ready = digits.length === 8;
        store.rates = [];
        store.heading = '';
        store.error = '';
        store.consulted = false;
        store.open = false;
        if (store.ready) store.lookup(false);
      });

      document.addEventListener('consulado:cep-cleared', (event) => {
        if (!event.detail || event.detail.source !== 'product') return;
        const store = Alpine.store('xCepQuote');
        store.cep = '';
        store.display = '';
        store.ready = false;
        store.consulted = false;
        store.rates = [];
        store.heading = '';
        store.error = '';
        store.open = false;
        store.requestId += 1;
      });

      Alpine.data('xCepProduct', (el) => ({
        sectionId: el.dataset.sectionId,
        cep: '',
        display: '',
        ready: false,
        loading: false,
        consulted: false,
        rates: [],
        error: '',
        heading: '',
        requestId: 0,
        init() {
          loadLabels(el);
          const saved = savedCep();
          this.cep = saved;
          this.display = formatCep(saved);
          this.ready = saved.length === 8;
          if (this.ready) this.lookup();

          const variantInput = document.getElementById(`update-variant-${this.sectionId}`);
          if (variantInput) {
            variantInput.addEventListener('change', () => {
              if (this.ready) this.lookup();
            });
          }
          document.addEventListener(`eurus:product:quantity-changed-${this.sectionId}`, () => {
            if (this.ready) this.lookup();
          });
          document.addEventListener('consulado:cep-set', (event) => {
            if (!event.detail || event.detail.source !== 'quote') return;
            const digits = digitsOnly(event.detail.cep);
            if (digits === this.cep) return;
            this.cep = digits;
            this.display = formatCep(digits);
            this.ready = digits.length === 8;
            this.rates = [];
            this.heading = '';
            this.error = '';
            this.consulted = false;
            if (this.ready) this.lookup();
          });
          document.addEventListener('consulado:cep-cleared', (event) => {
            if (!event.detail || event.detail.source !== 'quote') return;
            this.cep = '';
            this.display = '';
            this.ready = false;
            this.consulted = false;
            this.rates = [];
            this.heading = '';
            this.error = '';
            this.requestId += 1;
          });
        },
        onInput(raw, input) {
          const digits = digitsOnly(raw);
          this.display = formatCep(digits);
          if (input) input.value = this.display;
          if (digits === this.cep) return;
          this.cep = digits;
          this.ready = digits.length === 8;
          this.rates = [];
          this.heading = '';
          this.error = '';
          this.consulted = false;
          rememberCep(digits);
          publishCep(digits, 'product');
          if (this.ready) this.lookup();
        },
        clear() {
          this.cep = '';
          this.display = '';
          this.ready = false;
          this.loading = false;
          this.consulted = false;
          this.rates = [];
          this.heading = '';
          this.error = '';
          this.requestId += 1;
          rememberCep('');
          publishClear('product');
        },
        async lookup() {
          if (!labels || this.cep.length !== 8) return;
          const cep = this.cep;
          const requestId = ++this.requestId;
          const variantId = document.getElementById(`update-variant-${this.sectionId}`)?.value;
          const quantityInput = document.getElementById(`Quantity-atc-${this.sectionId}`);
          const quantity = Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
          this.loading = true;
          this.error = '';
          try {
            const result = await fetchProductRates(cep, variantId, quantity);
            if (requestId !== this.requestId || this.cep !== cep) return;
            this.rates = result.rates;
            this.heading = result.heading;
            this.error = result.error || '';
            this.consulted = !result.error;
          } catch (error) {
            console.log(error);
            if (requestId === this.requestId && this.cep === cep) this.error = labels.error;
          } finally {
            if (requestId === this.requestId) this.loading = false;
          }
        }
      }));
    });
  });
}
